import { render, staticRenderFns } from "./IconArrowUpOutline.vue?vue&type=template&id=268575c5"
import script from "./IconArrowUpOutline.vue?vue&type=script&lang=js"
export * from "./IconArrowUpOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports